import React, { Fragment, useEffect, useState, useContext } from "react";
import axios from "axios";

import Pagina from "../comun/Pagina";
import Contexto from '../comun/Contexto';
import mundo from "../../img/mundo.png";
import { useForm } from "react-hook-form";
import { PanelInfoSitio } from "./ConsultaPorSitio";

import datosDummy from "./tabla_consulta_sitio.json";
import { Cell, Body, Header, HeaderCell, HeaderRow, Row, Table } from "@table-library/react-table-library/table";
import Tabla from "../comun/Tabla";

const estilo14 = {width:"14%"};
const estilo16 = {width:"16%"};
const columnas = [
    {style: estilo14, nombre:"Fecha y hora", dataKey:"fecha"},
    {style: estilo14, nombre:"Latitud", dataKey:"latitud"},
    {style: estilo14, nombre:"Longitud", dataKey:"longitud"},
    {style: estilo14, nombre:"Magnitud", dataKey:"magnitud"},
    {style: estilo14, nombre:"Intensidad máxima", dataKey:"INT_MAX"},
    {style: estilo14, nombre:"Intensidad sitio", dataKey:"I"},
    {style: estilo16, nombre:"Epicentro", dataKey:"NOMBRE_CENTRO_POBLADO"},        
];

const CPSTabla=(props) =>{
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /* Estado */
    const[datos, setDatos] = useState([{}]);

    /* Efectos */
    useEffect(()=>{
        const traerDatos = async(url) => {
			const res = await axios(url);
            setDatos(res.data);            
		};
        traerDatos(urlBaseRest + "sismos_consulta_centro_poblado/"+props.idCentroPoblado);
        //setDatos(datosDummy);
    }, []);

    const {register, handleSubmit, watch, formState: { errors }} = useForm();   

    /* Render */
    return (  
        <Pagina 
        titulo="Consulta por sitio"
        imgSrc={mundo}
        imgAlt="Consulta por sitio"        
        handleSubmit={handleSubmit}
        explicacion={
            <React.Fragment>
            En la tabla se presentan las intensidades asociadas al sitio seleccionado.<br/>
            En el botón "Generar mapa" se pueden observar los epicentros de los sismos resultantes
            </React.Fragment>
        }
        contenidoPrincipal= {
            <React.Fragment>
            <br/>
            <PanelInfoSitio nombreMunRef ={props.nombreMunRef} nombreCPRef={props.nombreCPRef}/>
            <br/>
                        
            <Tabla columnas ={columnas } datos={datos}/>
                                  
            <div >  
            <br/>&nbsp;
            <a href={urlBaseRest+"sismos_consulta_centro_poblado_excel/"+props.idCentroPoblado}
            className="TablaRespuestasLinkExcel">
                Descargar XLS
            </a>                
            <br/>&nbsp;
            <div>
                <button 
                className="BotonAvanzar"
                type="button"
                onClick={ props.irAConsultaSelCP }>
                    Nueva consulta
                </button>
                &nbsp;        
                <button 
                className="BotonAvanzar"
                type="button"
                onClick={ props.irAConsultaMapa }>
                    Generar mapa
                </button>
            </div>
            </div>
        </React.Fragment>
        }    
        />        
    );
}

export default CPSTabla;